import { useMemo } from 'react';
import { ClbButton } from '@celebration/react';
import { ClbLoading } from '@celebration/react/ClbLoading/ClbLoading';
import './reports-generate.scss';
import dayjs from 'dayjs';
import IReportsDownloadProps from './interfaces/IReportsDownloadProps';
import { useToast } from '../../../../app/contexts/toast/toast.context';
import RoundManagerApiService from '../../../../common/services/roundmanager-api';
import i18n from '../../../../lib/i18n';
import { isNotEmpty, isNullOrEmpty } from '../../../../utils/string-utils';

function ReportsGenerate({
    reportType,
    startDateFilter,
    endDateFilter,
    channel,
    isGeneratingReport,
    setIsGeneratingReport,
    setFilterErrorValues,
}: Readonly<IReportsDownloadProps>) {
    const { setToast } = useToast();

    const getStringError = (text: any): string => {
        return isNullOrEmpty(text) ? i18n.t('RequiredFieldMessage') : '';
    };

    const isDateValid = (date: any): boolean => dayjs(date).isValid();

    const getDateError = (date: any): string => {
        return !isDateValid(date) ? i18n.t('RequiredFieldMessage') : '';
    };

    const validateFilterValues = (): boolean => {
        setFilterErrorValues({
            reportType: getStringError(reportType),
            startDate: getDateError(startDateFilter),
            endDate: getDateError(endDateFilter),
        });

        return (
            isNotEmpty(reportType) &&
            isDateValid(startDateFilter) &&
            isDateValid(endDateFilter)
        );
    };

    const handleDownload = async () => {
        setIsGeneratingReport(true);

        const isValid: boolean = validateFilterValues();

        if (isValid) {
            const { error } =
                await RoundManagerApiService.Reports.downloadReportAsync(
                    reportType,
                    startDateFilter,
                    endDateFilter,
                    channel,
                );

            if (error) {
                setToast('negative', i18n.t('Erro'), error?.message);
            }
        }

        setIsGeneratingReport(false);
    };

    const downloadButtonLabel = useMemo(() => {
        return isGeneratingReport
            ? i18n.t('GerandoRelatorio')
            : i18n.t('GerarRelatorio');
    }, [isGeneratingReport]);

    return (
        <div className="reports-generate__container">
            <ClbButton
                size="sm"
                styleType="primary"
                label={downloadButtonLabel}
                onClick={handleDownload}
                disabled={isGeneratingReport}
                data-testid="reports-download__button"
            />
            {isGeneratingReport && <ClbLoading size="sm" />}
        </div>
    );
}

export default ReportsGenerate;
